import { useTranslation } from 'react-i18next';

import { ImagesContainer } from 'components/shared';
import StyledBadge from 'components/shared/StyledBadge/StyledBadge';
import { usePalletsTypes } from 'constants/palletTypes';
import { useReportStatuses } from 'constants/reportStatuses';
import { useReportTypeLabels } from 'constants/reportTypes';
import { PalletReportDTO } from 'interfaces';

import styles from './DamagedPalletsInDeliveryCard.module.css';

type DamagedPalletsInDeliveryCardProps = {
   damagedPalletsReport: PalletReportDTO;
   supplierMode?: boolean;
};

const DamagedPalletsInDeliveryCard = ({
   damagedPalletsReport,
   supplierMode,
}: DamagedPalletsInDeliveryCardProps) => {
   const { t } = useTranslation();
   const { REPORT_STATUSES_AND_LABELS } = useReportStatuses();
   const { PALLET_TYPE_LABELS } = usePalletsTypes();
   const { REPORT_TYPE_LABELS } = useReportTypeLabels();

   return (
      <div className={styles.container}>
         {!supplierMode && (
            <div className={styles.dataItem}>
               <span className={styles.label}>{t('damaged_lost_by_client.table.order_id')}</span>
               <span className={styles.value}>#{damagedPalletsReport.orderId}</span>
            </div>
         )}
         <div className={styles.dataItem}>
            <span className={styles.label}>{t('in_delivery.table.report_status')}</span>
            <span className={styles.value}>
               <StyledBadge
                  text={REPORT_STATUSES_AND_LABELS[damagedPalletsReport.status!].label}
                  variant={REPORT_STATUSES_AND_LABELS[damagedPalletsReport.status!].variant}
               />
            </span>
         </div>
         {damagedPalletsReport.damagedPallets.map((damagedPalletsItem, index) => (
            <div key={index} className={styles.innerContainer}>
               {!supplierMode && (
                  <div className={styles.dataItem}>
                     <span className={styles.label}>
                        {t('damaged_by_client.table.damage_type')}
                     </span>
                     <span className={styles.value}>
                        {REPORT_TYPE_LABELS[damagedPalletsItem.reportType]}
                     </span>
                  </div>
               )}
               <div className={styles.dataItemsGroup}>
                  <div>
                     <span className={styles.label}>
                        {t('damaged_by_client.table.pallet_type')}
                     </span>
                     <span className={styles.value}>
                        {PALLET_TYPE_LABELS[damagedPalletsItem.type]}
                     </span>
                  </div>
                  <div>
                     <span className={styles.label}>{t('client_orders.table.pallets_amount')}</span>
                     <span className={styles.value}>{damagedPalletsItem.amount}</span>
                  </div>
               </div>
               <ImagesContainer
                  imageURLs={damagedPalletsItem.images}
                  isImagesPreviewLeftSidePosition
               />
            </div>
         ))}
      </div>
   );
};

export default DamagedPalletsInDeliveryCard;
